export enum TourKeys {
  NavigationTour = 'navigation-tour',
  GetToKnowTheInterface = 'get-to-know-the-interface-tour',
  LearnToShare = 'share-tour',
}

export const StepKeys = {
  NAVIGATION_TOUR: {
    WELCOME: 'welcome',
    PAN: 'pan',
    ZOOM: 'zoom',
    ADD_NODES: 'add-nodes',
    CONNECT_NODES: 'connect-nodes',
    RUN_MODEL: 'run-model',
    FINISH: 'finish',
  },
  GET_TO_KNOW_THE_INTERFACE: {
    WELCOME: 'welcome',
    CHANGE_RECIPE_NAME: 'change-recipe-name',
    SIDE_MENU: 'side-menu',
    FINISH: 'finish',
  },
};

export const ComponentKeys = {
  FLOW: 'flow',
};
